/*
練習道場の難易度の対応表。道場の slug から決める。
仮の値 (10/19)。道場の問題は難易度の値を持たないので、道場の題 (HTML と CSS、Git、アルゴリズムなど) を、
読む前に要る知識の量で並べただけ。代表が決めた基準ではない。決まったらこの表だけを直す。
表に無い道場は決められないので、難易度を出さない
*/

const DOJO_LEVEL_BY_SLUG: Readonly<Record<string, string>> = {
  "dojo-hc": "入門",
  "dojo-git": "入門",
  "dojo-lx": "入門",
  "dojo-js": "初級",
  "dojo-python": "初級",
  "dojo-sql": "初級",
  "dojo-java": "初級",
  "dojo-web": "初級",
  "dojo-pr": "初級",
  "dojo-ai": "初級",
  "dojo-os": "中級",
  "dojo-cs": "中級",
  "dojo-ts": "中級",
  "dojo-re": "中級",
  "dojo-ex": "中級",
  "dojo-go": "中級",
  "dojo-fd": "中級",
  "dojo-algo": "中級",
  "dojo-docker": "中級",
  "dojo-cloud": "中級",
  "dojo-req": "中級",
  "dojo-auth": "上級",
  "dojo-design": "上級",
  "dojo-consul": "上級",
};

export function dojoLevelOf(slug: string): string | undefined {
  return Object.hasOwn(DOJO_LEVEL_BY_SLUG, slug) ? DOJO_LEVEL_BY_SLUG[slug] : undefined;
}
